import { render } from "./institution-start-year-incremental-field.vue?vue&type=template&id=befeab84"
import script from "./institution-start-year-incremental-field.vue?vue&type=script&lang=js"
export * from "./institution-start-year-incremental-field.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__